import { render, staticRenderFns } from "./igt-wheel-feature.vue?vue&type=template&id=7694784a&scoped=true&"
import script from "./igt-wheel-feature.vue?vue&type=script&lang=js&"
export * from "./igt-wheel-feature.vue?vue&type=script&lang=js&"
import style0 from "./igt-wheel-feature.vue?vue&type=style&index=0&id=7694784a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7694784a",
  null
  
)

export default component.exports